import React, { Component } from "react";
import { connect } from "react-redux";
import { getAttributeFields, createAttributeField, updateAttributeField, deleteAttributeField, getMappedFields } from "../../actions/actionAttributeMapping";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Button, Label, Row, Input, Col, Card, CardHeader, CardBody, CardFooter, Alert } from "reactstrap";
import Select from "react-select";
import Proptypes from "prop-types";
import DataTable from "../../components/Table/Table";
import { NotificationManager } from "react-notifications";

const defaultstate = {
  userField: null,
  attributeName: '',
  addMappingModal: false,
  mappingEdit: false,
  attributeId: null,
  deleteMappingModal: false,
}

class MappingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultstate
    };
    this.openMappingAddModal = this.openMappingAddModal.bind(this);
    this.handleMappingDropDown = this.handleMappingDropDown.bind(this);
    this.addMapping = this.addMapping.bind(this);
    this.toggleMapping = this.toggleMapping.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.deleteMappingConfirm = this.deleteMappingConfirm.bind(this);
    this.toggleDeleteMappingModal = this.toggleDeleteMappingModal.bind(this);
    this.deleteMapping = this.deleteMapping.bind(this);
  }

  async addMapping(event) {
    event.preventDefault()
    event.stopPropagation()
    try {
      let data = {
        target_sso_attribute_mapping: {
          attribute_name: event.target['attributeName'].value,
          user_field: event.target['userField'].value
        }
      }
      if (this.state.mappingEdit === true) {
        data.target_sso_attribute_mapping.sso_attribute_id = this.state.attributeId;
        await this.props.updateAttributeField(data)
      } else {
        data.target_sso_attribute_mapping.sso_id = this.props.sso_id;
        await this.props.createAttributeField(data)
      }
      this.handleSuccess()
    } catch (e) {
      this.handleFailure();
    }
  }

  toggleDeleteMappingModal() {
    this.setState({
      deleteMappingModal: !this.state.deleteMappingModal,
    });
  }

  deleteMappingConfirm(sso_attribute_id) {
    this.setState(
      {
        deleteMappingModal: !this.state.deleteMappingModal,
        attributeId: sso_attribute_id
      });
  }

  handleSuccess() {
    const { successMessage, failureMessage } = this.props;

    if (failureMessage) {
      return this.handleFailure()
    }

    this.setState({ ...defaultstate });
    NotificationManager.success(successMessage, "Attribute Mapping", 3000);
    this.props.getMappedFields({ sso_id: this.props.sso_id });
  }

  handleFailure() {
    const { failureMessage } = this.props;
    if (failureMessage) {
      NotificationManager.error(failureMessage, "Attribute Mapping", 3000);
    } else {
      NotificationManager.error('Something Went Wrong', "Attribute Mapping", 3000);
    }
  }

  async openMappingAddModal(e) {
    e.preventDefault();
    this.setState({
      ...defaultstate,
      addMappingModal: !this.state.addMappingModal,
    });
  }

  handleMappingDropDown(value) {
    this.setState({ userField: value });
  }

  toggleMapping() {
    this.setState({ addMappingModal: !this.state.addMappingModal });
  }

  async componentDidMount() {
    const mappings = await this.props.getAttributeFields();
    let maplist = []
    mappings.response.fields.forEach(element => maplist.push({
      label: element,
      value: element
    }))
    this.setState({ optMappings: maplist });
    this.props.getMappedFields({ sso_id: this.props.sso_id });
  }

  async deleteMapping() {
    const data = {
      sso_attribute_id: this.state.attributeId
    }
    try {
      await this.props.deleteAttributeField(data);
      this.handleSuccess();
    } catch (e) {
      this.handleFailure();
    }
  }

  renderAttributeMapping() {
    const columns = [
      {
        type: "text",
        accessor: "user_field",
        name: "User Field",
        filterable: true,
        sortable: true,
      },
      {
        type: "text",
        accessor: "attribute_name",
        name: "Attribute",
        filterable: true,
        sortable: true
      },
    ];

    const actions = [
      { id: "edit", icon: "fa-pencil", description: "Edit" },
      { id: "delete", icon: "fa-trash", description: "Delete" },
    ];

    const onAction = async (action, item) => {
      switch (action) {
        case "edit":
          this.setState({
            addMappingModal: true,
            mappingEdit: true,
            attributeId: item.sso_attribute_id,
            attributeName: item.attribute_name,
            userField: item.user_field
          })
          break;

        case "delete":
          this.deleteMappingConfirm(item.sso_attribute_id);
          break;
      }
    }

    return (
      <div>
        <DataTable
          id="sso-attribute-mapping"
          data={this.props.attributeMapping}
          columns={columns}
          actions={actions}
          onAction={onAction}
        />
      </div>
    );
  }

  render() {
    const { attributeMapping } = this.props;
    let optMappings = this.state.optMappings;
    return (
      <div>
        <CardHeader style={{ justifyContent: 'space-between' }}>
          <div className="title-head">
            <i className="fa fa-edit"></i> <strong>Attribute Mapping</strong></div>
          <button className="pull-right adduser-btn" size="sm" color="dark"
            onClick={this.openMappingAddModal}>
            <i className="fa fa-plus" aria-hidden="true"></i>
            Add SSO Mapping
          </button>
        </CardHeader>
        <CardBody className="p-0">
          <Row>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <p className="viewGroupHeadingP">
                    Map {this.props.sso_type} attributes to user fields
                  </p>
                </Col>
              </Row>
              {attributeMapping && attributeMapping.length > 0 ?
                <div>{this.renderAttributeMapping(attributeMapping)}</div>
                : <Card className="p-3"><CardBody>No attribute mapping</CardBody></Card>}
            </Col>
          </Row>
        </CardBody>
        <Modal centered={true} isOpen={this.state.addMappingModal} toggle={this.toggleMapping} className="user-modal">
          <Form onSubmit={this.addMapping}>
            <ModalHeader toggle={this.toggleMapping}>Attribute Mapping</ModalHeader>
            <ModalBody>
              <Label className="requiredasterisk">User Field </Label>
              <Select
                id="state-select"
                autoFocus
                value={this.state.userField}
                options={optMappings}
                name="userField"
                onChange={this.handleMappingDropDown}
              />
              <br />
              <div style={{ "marginTop": "10px" }}>
                <Label className="requiredasterisk">{this.props.sso_type} Attribute</Label>
                <Input name="attributeName" type="text" defaultValue={this.state.attributeName} />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button onClick={this.toggleMapping}
                className="cancel-button"
                size="sm" color="basic"> Cancel</Button>
              <Button type="submit" size="sm"
                className="submit-button"
                color="primary"> {(this.state.mappingEdit) ? 'Update' : 'Add'}</Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal centered={true} isOpen={this.state.deleteMappingModal} toggle={this.toggleDeleteMappingModal} className="user-modal">
          <ModalHeader toggle={this.toggleDeleteMappingModal}>Are you sure you want to delete this mapping?
          </ModalHeader>
          <ModalFooter>
            <Button onClick={this.toggleDeleteMappingModal}
              className="cancel-button"
              size="sm" color="basic"> Close</Button>
            <Button onClick={this.deleteMapping}
              className="delete-button"
              size="sm" color="danger">Delete</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

MappingTable.propTypes = {
  optMappings: Proptypes.array,
  sso_id: Proptypes.string,
  sso_type: Proptypes.string,
  attributeMapping: Proptypes.array,
};

export default connect(state => ({
  optMappings: state.attribute_mapping.optMappings || [],
  attributeMapping: state.attribute_mapping.attributeMapping || [],
  successMessage: state.attribute_mapping.successMessage || null,
  failureMessage: state.attribute_mapping.failureMessage || null,
}),
  dispatch => ({
    getAttributeFields: () => dispatch(getAttributeFields()),
    getMappedFields: (data) => dispatch(getMappedFields(data)),
    createAttributeField: (data) => dispatch(createAttributeField(data)),
    updateAttributeField: (data) => dispatch(updateAttributeField(data)),
    deleteAttributeField: (data) => dispatch(deleteAttributeField(data))
  }))(MappingTable);
  